/**
 * App Settings — Learn-Mode inline tips.
 *
 * Anchored in `routes/social/Settings.tsx`.
 */

import type { LearnTip } from "./types";

export const settingsTips: LearnTip[] = [
  {
    key: "social-settings-general",
    title: "General Settings",
    body: "Your personal defaults for this app, such as the timezone used when you schedule a post.",
  },
  {
    key: "social-settings-utm-defaults",
    title: "Links & Tracking",
    body: "Sets whether links in new posts automatically get UTM tracking added, so Google Analytics can show which posts drive visits. This applies organization-wide to everyone on your team, not just you, and is saved separately from your personal settings above.",
  },
  {
    key: "social-settings-notifications",
    title: "Notifications",
    body: "Choose which alerts reach you in the bell at the top of the app, and whether they also go to your phone in the Plerity Social app. Failed posts, approvals, expiring sign-ins, comment digests and finished renders are on by default; routine 'post published' alerts are off. Expiring or broken account sign-ins always show on the Connected Accounts page regardless of these settings.",
  },
  {
    key: "social-notification-bell",
    title: "Notification bell",
    body: "Your alerts in one place: failed posts, posts waiting for your approval, approval decisions on your posts, expiring account sign-ins, new-comment digests and finished video renders. The red badge counts unread alerts; click one to open it, or mark them all read.",
    bullets: [
      "Each alert is personal — teammates get their own.",
      "Change which alerts you get under Settings → Notifications.",
    ],
  },
  {
    key: "social-inbox-rules",
    title: "Inbox Rules",
    body: "Automatically hide a comment, assign it to a teammate, or move it to a bucket when it matches a condition you set — right after the inbox's automatic triage pass. Every new rule is created off; a comment a teammate already triaged by hand is never touched by a rule.",
    bullets: [
      "The first matching rule acts and stops — a comment is never acted on by two rules.",
      "Every action a rule takes is logged to the same activity trail a manual click would write.",
    ],
  },
  {
    key: "social-rss-feeds",
    title: "RSS Feeds",
    body: "Add a client's blog or news feed and every new post becomes a draft waiting in Approvals, with the link and UTM tracking pre-filled. A feed never schedules or publishes on its own — someone always reviews each draft first.",
  },
];
